module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "alert alert-success"
  }, [_vm._v("\n\t\t尊敬的管理员，欢迎来到" + _vm._s(_vm.$store.state.appName) + "后台管理系统。\n\t")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-9e6f9d94"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/backyard/view/index/Index.vue
// module id = 1014
// module chunks = 1